import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputContent from './InputComponent';
import PreviewComponent from './PreviewComponent';
import useStyles from './styles';

const urlBase = '/uploads';


const ImageUploader = ({
  id, setFieldValue, title, text, hint, value, clearPreview, disabled,
}) => {
  const imageFromServerFlag = typeof value === 'string';

  const [showInput, setShowInput] = useState(!imageFromServerFlag);
  const [previewImage, setPreviewImage] = useState(null);

  if (clearPreview && !showInput) {
    setShowInput(true);
  }

  const onChange = async (evt) => {
    const file = evt.target.files[0];
    evt.target.value = null;
    try {
      await setFieldValue(id, file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        if (!clearPreview) {
          setPreviewImage(reader.result);
          setShowInput(false);
        }
      };
    } catch (error) {
      setShowInput(true);
    }
  };

  const reset = () => {
    if (!disabled) {
      setFieldValue(id, null);
      setShowInput(true);
    }
  };

  const classes = useStyles();
  if (showInput) {
    return (
      <InputContent
        id={id}
        classes={classes}
        title={title}
        text={text}
        hint={hint}
        onChange={onChange}
      />
    );
  }

  const url = imageFromServerFlag ? `${urlBase}/${value}` : previewImage;
  return (
    <PreviewComponent
      src={url}
      removeImage={reset}
      title={title}
      disabled={disabled}
    />
  );
};

ImageUploader.defaultProps = {
  value: null,
  clearPreview: false,
};

ImageUploader.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  clearPreview: PropTypes.bool,
};

export default ImageUploader;
